(function (d, t) {
  var BASE_URL = "https://chat.datanest.earth";
  var g = d.createElement(t), s = d.getElementsByTagName(t)[0];
  g.src = BASE_URL + "/packs/js/sdk.js";
  g.defer = true;
  g.async = true;
  s.parentNode.insertBefore(g, s);
  g.onload = function () {
    window.chatwootSDK.run({
      websiteToken: '6uzstW42fnQveArHGQhvsiKp',
      baseUrl: BASE_URL
    })
  }
})(document, "script");

window.chatwootSettings = {
  hideMessageBubble: true,
  position: "right",
  locale: "en",
  type: "standard"
};
